import { Icon, Text } from 'ui';
import { SearchItemRow } from '../../../search-items/search-item-row';

/** @deprecated Provisional shape based on current usage only, not a real domain type. To unblock the JSX->TS port. */
type P = {
  title: string;
} & Record<string, unknown>;

const RecentSearchItem = ({ title, ...itemActionProperties }: P) => (
  <SearchItemRow icon={<Icon icon="history-line" size="small" />} itemActionProps={itemActionProperties}>
    <Text ellipsis>{title}</Text>
  </SearchItemRow>
);

export default RecentSearchItem;
